export const SUPPORT_USER_ID = 107;
export const ADMIN_USER_ID = 1;

export const INTERNAL_EMAIL_DOMAIN = '@myre.fr';

export const GOD_USER_IDS = [SUPPORT_USER_ID] as const;

export const ADMIN_USER_IDS = [...GOD_USER_IDS, ADMIN_USER_ID] as const;

export const CSM_USER_IDS = [
  ...ADMIN_USER_IDS,
  293,
  549,
  580,
  730,
  796,
] as const;

/**
 * Every staff gate recognises its users by one of the ids above, so an id past
 * this one can never pass one.
 */
export const MAX_STAFF_USER_ID = Math.max(...CSM_USER_IDS);

/**
 * Customers no cross-customer staff operation may reach, in either direction:
 * a bulk grant or revoke must never open or close a membership on them.
 */
export const PROTECTED_CUSTOMER_IDS = [19, 20, 40, 78, 126] as const;
